define((require, exports, module) => {
    'use strict';

    const CsrfTokenModel = require('system/models/CsrfTokenModel');

    const csrfToken = new CsrfTokenModel();

    // TODO: replace `csrfToken.get('token')` with `csrfToken.getToken()`
    // and expose only those methods instead of the model instance
    csrfToken.updateFromUserData = async function({ email }) {
        return csrfToken.set('email', email).save();
    };

    csrfToken.reset = function() {
        csrfToken.set('token', '');
    };

    module.exports = csrfToken;
});
